/**
 * De opmaak die meer dan één stap van het leerlingscherm gebruikt.
 *
 * De kleuren zijn de namen uit index.css (var(--accent) enzovoort). Wat maar
 * in één stap voorkomt, staat in die stap zelf.
 */

const kaart = {
  background: 'var(--wit)',
  borderRadius: 12,
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
};

export const stijlen = {
  kaart,

  // De toetsstappen: links de tekst, rechts de vragen, even breed.
  toetsRaster: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 24,
    maxWidth: 1400,
    margin: '0 auto',
    padding: '24px',
  },
  toetsPaneel: {
    ...kaart,
    padding: 24,
    maxHeight: 'calc(100vh - 180px)',
    overflow: 'auto',
  },
  paneelLabel: { marginBottom: 16, color: 'var(--tekst-3)', fontSize: 14, textTransform: 'uppercase' },
  paneelTitel: { marginBottom: 24, color: 'var(--inkt)' },

  // De grote knop onderaan een stap ("Naar de toets", "Verstuur antwoorden").
  groteKnop: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    border: 'none',
    borderRadius: 8,
    cursor: 'pointer',
    fontWeight: 500,
    width: '100%',
    transition: 'all 0.2s',
    background: 'var(--accent)',
    color: 'var(--wit)',
    padding: '16px 32px',
    fontSize: 18,
    marginTop: 32,
    marginBottom: 8,
  },

  // Het blauwe verloop van Anna Maria.
  annaMariaVerloop: 'linear-gradient(135deg, var(--anna-maria) 0%, var(--anna-maria-2) 100%)',

  // Een vraag in de toets.
  vraagBlok: { marginBottom: 32 },
  vraagNummer: { marginBottom: 12 },
  vraagTekst: { marginBottom: 16, color: 'var(--tekst-2)' },
};
